<template>

  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{ errorMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{ successMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
      <div>
        <terminals-wavelet-form
          @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage"
          :key="componentKey"
          :accountPosWaveletId="accountPosWaveletId"
          :waveletId="wavelet_id"
          :viewMode="viewMode"
        ></terminals-wavelet-form>
      </div>
    </a-drawer>
    
    <input
      type="text"
      class="form-control mb-3"
      v-model="searchQuery"
      placeholder="Search site..."
      @input="fetchSites"
    />

    <div class="table-responsive">
      <a-spin :spinning="loading">
        <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
          :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
          no-data-template="Empty" @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log"
          @vuetable:load-error="onLoadError" @vuetable:pagination-data="onPaginationData">

          <template slot="actions" slot-scope="props">
            <center>
              <div v-if="serverType == 'ho'" class="table-button-container">
                <button id="view" class="btn btn-success btn-sm"
                  @click.prevent="showDrawer(props.rowData.site_id)">View</button>
                <button id="edit" class="btn btn-warning btn-sm"
                  @click.prevent="showDrawer(props.rowData.site_id)">Edit</button>
                <a-popconfirm title="You are about to delete this record?" @confirm="deleteRow(props.rowData.id)" okText="Delete"
                  cancelText="Cancel">
                  <a class="btn btn-danger btn-sm text-white">Delete</a>
                </a-popconfirm>
              </div>
            </center>
          </template>

        </vuetable>
      </a-spin>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent'  : ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import {
  mapState,
  mapActions
} from 'vuex'
import WaveletPurchaseForm from '../Wavelet/WaveletPurchaseForm.vue'
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest.js';
import draggable from "vuedraggable";
import moment from "moment";
import { formatStatus } from "../../utilities.js"
import TerminalsWaveletForm from '../Wavelet/TerminalsWaveletForm.vue';
var component_x;

export default {
  name: 'wavelets-table',
  props: {
    type: {
      type: String
    },
    title: String,
    accountPosWaveletId: {  
      type: Number, 
      required: true 
    },
    wavelet_id: { 
      type: Number, 
      required: true 
    }
  },
  components: {
    Vuetable,
    VuetablePagination,
    WaveletPurchaseForm,
    draggable,
    TerminalsWaveletForm
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType'])
  },
  data() {
    return {
      mode: 1,
      searchQuery: "",
      loading: false,
      viewMode: false,
      itemStatus: '',
      errors: [],
      exportSelection: 0,
      profileAction: "",
      checkedFields: [],
      checkedItems: [],
      availableFields: [],
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      drawerVisible: false,
      visible: false,
      apiURL: "",
      fields: ["site_id", "site_code", "site_name"],
      sortOrder: [{
        field: "site_name",
        direction: "asc"
      }],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
        }
      },
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
    }
  },
  watch: {
    // currentApiURL: function () {
    //   this.$refs.vuetable.resetData()
    //   this.apiURL = this.currentApiURL
    //   this.apiURL = this.endPoint + "pos_wavelet_terminals/get_site_terminals?account_pos_wavelet_id="+this.accountPosWaveletId
    // },
    // parameters: function () {
    //   this.apiURL = this.currentApiURL
    // //   this.apiURL = this.apiURL + this.parameters
    //  this.apiURL = this.endPoint + "pos_wavelet_terminals/get_site_terminals?account_pos_wavelet_id="+this.accountPosWaveletId
    
    // //   this.$refs.vuetable.selectedTo = []
    // //   this.checkedItems = []
    // },
    // currentProfile: function () {
    //   this.initializeTable()
    // },
  },
  methods: {
    ...mapActions(['updateProfileId']),
    closeDrawer() {
      this.onClose()
    },
    refreshPage() {
      this.onClose()
      this.$refs.vuetable.refresh()
      this.successMessage = "Successful Operation"
      this.errorMessage = null
    },
    showDrawer(id) {
      if (event.target.id == "view") {
        this.viewMode = true;
      } else {
        this.viewMode = false;
      }
      this.componentKey++
      this.updateProfileId(id)
      this.visible = true
    },
    onClose() {
      this.errors = [];
      this.drawerVisible = false
      this.visible = false
      this.componentKey++
    },
    log(checked, value) {
      this.checkedItems = this.$refs.vuetable.selectedTo
      if (this.checkedItems.length == 1) {
        this.itemStatus = value.status
        // console.log(this.itemStatus)
      } else {
        this.itemStatus = ''
      }
    },
    async onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.")
          this.$router.push("/")
        }
      } else {
        if (error.response.data.error == "Session expired") {
          alert("Session is already expired. Please login again.")
          document.getElementById("logoutButton").click()
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    // jirah
    async deleteRow(id) {
        let site_id = id
        let wavelet_payload = {"wavelet_id": this.wavelet_id, "terminal_site_id": site_id, "mode": this.mode}
        let post_request = await HTTPRequest.postRequest(this.endPoint + 'wavelets/update_purchase_settings', null, wavelet_payload)
        
        if (post_request.status == 'success') {
            this.$notification['success']({
                message: 'Wavelet Markeplace',
                description: "Purchase Update Successful: The selected records have been successfully deleted."
            });
        } else {
            this.$notification['error']({
                message: 'Wavelet Marketplace',
                description: "Purchase update error: " + post_request.error
            }); 
        }
        this.refreshPage()
    },
    removeMessage(type) {
      if (type == 'error')
        this.errorMessage = null
      else
        this.successMessage = null
    },
     fetchSites() {
      this.loading = true;
      this.apiURL = `${this.endPoint}pos_wavelet_terminals/get_pos_wavelets_site?account_pos_wavelet_id=${this.accountPosWaveletId}&search=${this.searchQuery}`;
      this.loading = false;
    },
  },
  beforeMount: async function () {
    const SiteWaveletCustomList = localStorage.getItem(this.currentProfile + "SiteWaveletProfileCheckedFields")
    if (SiteWaveletCustomList != undefined && SiteWaveletCustomList != null && SiteWaveletCustomList != "[]") {
      this.checkedFields = JSON.parse(SiteWaveletCustomList)
      this.fields = this.checkedFields.map(column => {
       if (column === "site_name") {
          return {
            name: "site_name",
            title: "site name"
          }
        }  else return column
      })
      this.fields.push("__slot:actions")
      this.fields.unshift("__checkbox")
      this.initLoad++
      } else {
        this.checkedFields = ["site_id", "site_code", "site_name"];
        this.fields = [
          // "__checkbox",
          {name: "site_id", title: "site id"}, {name: "site_code", title: "site code"}, {name: "site_name", title: "site name"},,
          "__slot:actions"
        ];
      }
      localStorage.removeItem(this.currentProfile + "SiteWaveletProfileCheckedFields")
    
  },
  mounted: async function () {
    this.fetchSites();
  }
}
</script>

<style>
</style>
